// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-up {
  position: fixed;
  height: 100%;
  isolation: isolate;
  background-color: rgba(0, 0, 0, 0.1);
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;
  z-index: -1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.slide-up-inner {
  position: relative;
  transform: translateY(110%);
  transition: 500ms;
}
.slide-up-inner.show {
  transform: translateY(0);
}
.slide-up-inner .common-slide-up-container {
  padding: 40px 20px 60px;
  border-radius: 16px 16px 0px 0px;
  background-color: white;
}
.slide-up-inner .common-slide-up-container .common-slide-up-scrollable {
  max-height: 80vh;
  overflow: auto;
}
.slide-up-inner .common-slide-up-container-updated {
  padding: 40px 20px 60px;
  border-radius: 16px 16px 0px 0px;
  background-color: white;
}
.slide-up-inner .common-slide-up-container-least-padding {
  padding: 0px 20px 20px;
  border-radius: 16px 16px 0px 0px;
  background-color: white;
}
.slide-up.show {
  z-index: 700;
}
.slide-up.show .slide-up-child {
  z-index: 720;
}
@media (hover: hover) {
  .slide-up.show {
    left: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/CommonSlideUp/slideUp.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,SAAA;EACA,6BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AACJ;AACI;EACI,kBAAA;EACA,2BAAA;EACA,iBAAA;AACR;AAAQ;EACI,wBAAA;AAEZ;AAAQ;EACI,uBAAA;EACA,gCAAA;EACA,uBAAA;AAEZ;AAGY;EACI,gBAAA;EACA,cAAA;AADhB;AAKQ;EACI,uBAAA;EACA,gCAAA;EACA,uBAAA;AAHZ;AAKQ;EACI,sBAAA;EACA,gCAAA;EACA,uBAAA;AAHZ;AAOI;EACI,YAAA;AALR;AAMQ;EACI,YAAA;AAJZ;AAMQ;EALJ;IAMQ,SAAA;EAHV;AACF","sourcesContent":[".slide-up {\n    position: fixed;\n    height: 100%;\n    isolation: isolate;\n    background-color: rgba($color: #000000, $alpha: 0.1);\n    left: 50%;\n    transform: translate(-50%, 0);\n    top: 0;\n    z-index: -1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n\n    &-inner {\n        position: relative;\n        transform: translateY(110%);\n        transition: 500ms;\n        &.show {\n            transform: translateY(0);\n        }\n        .common-slide-up-container {\n            padding: 40px 20px 60px;\n            border-radius: 16px 16px 0px 0px;\n            background-color: white;\n            // max-height: 95%;\n            // overflow: auto;\n            // overscroll-behavior: contain;\n\n            .common-slide-up-scrollable {\n                max-height: 80vh;\n                overflow: auto;\n                // overscroll-behavior: contain;\n            }\n        }\n        .common-slide-up-container-updated {\n            padding: 40px 20px 60px;\n            border-radius: 16px 16px 0px 0px;\n            background-color: white;\n        }\n        .common-slide-up-container-least-padding {\n            padding: 0px 20px 20px;\n            border-radius: 16px 16px 0px 0px;\n            background-color: white;\n        }\n    }\n\n    &.show {\n        z-index: 700;\n        .slide-up-child {\n            z-index: 720;\n        }\n        @media (hover: hover) {\n            left: calc(50%);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
